import { create } from 'zustand';

interface IFeatureRestrictionState {
  visible: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

export const useFeatureRestrictionStore = create<IFeatureRestrictionState>((set) => ({
  visible: false,
  handleOpen: () => set({ visible: true }),
  handleClose: () => set({ visible: false }),
}));
